var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDesktopContents24Line = function SvgIconDesktopContents24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 4.65H7.3c-1.46 0-2.65 1.19-2.65 2.65v6.4c0 1.46 1.19 2.65 2.65 2.65h3.8v1.3H9v1.7h6v-1.7h-2.1v-1.3h3.8c1.46 0 2.65-1.19 2.65-2.65V7.3c0-1.46-1.19-2.65-2.65-2.65Zm.95 9.05a.95.95 0 0 1-.95.95H7.3a.95.95 0 0 1-.95-.95V7.3a.95.95 0 0 1 .95-.95h9.4a.95.95 0 0 1 .95.95v6.4Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.15H9v1.7h6v-1.7ZM15 11.15H9v1.7h6v-1.7Z",
    fill: "current"
  })));
};
export default SvgIconDesktopContents24Line;